export type HomeownerPromoKind = "complimentary" | "percentage" | "fixed";

export interface HomeownerPromoResolution {
  code: string;
  normalizedCode: string;
  label: string;
  kind: HomeownerPromoKind;
  discountPercent?: number;
  originalAmount: number;
  finalAmount: number;
  savingsAmount: number;
  highlevelProductId?: string | null;
  highlevelPriceId?: string | null;
}

export const normalizePromoCode = (value?: string | null): string =>
  String(value ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
